import { useState, useEffect, useRef } from 'react';

const INTERACTIVE_SELECTOR = 'button, a, [role="menuitem"]';
const KEEP_OPEN_SELECTOR = '[data-keep-open]';

const useToggleDropdown = (
  buttonRef,
  dropdownRef,
  closeOnClickInside = false,
  onCloseDropdown
) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const onCloseRef = useRef(onCloseDropdown);
  onCloseRef.current = onCloseDropdown;

  useEffect(() => {
    if (!showDropdown) return;

    function close() {
      setTimeout(() => {
        setShowDropdown(false);
        if (onCloseRef.current) onCloseRef.current();
      }, 150);
    }

    function handleMouseDown(event) {
      const target = event.target;

      if (buttonRef?.current?.contains(target)) return;

      const insideDropdown = dropdownRef?.current?.contains(target);

      if (!insideDropdown) {
        close();
        return;
      }

      if (
        closeOnClickInside &&
        target.closest?.(INTERACTIVE_SELECTOR) &&
        !target.closest?.(KEEP_OPEN_SELECTOR)
      ) {
        close();
      }
    }

    document.addEventListener('mousedown', handleMouseDown);
    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, [showDropdown, closeOnClickInside, buttonRef, dropdownRef]);

  return { showDropdown, setShowDropdown };
};

export { useToggleDropdown };
